import React from 'react';
import styles from '../LandingPage.module.css';
import extraStyles from '../LandingPageExtras.module.css';

const LeadersSection = () => {
  const leaders = [
    { initials: 'BB', name: 'Bobby Bonser', role: 'Director, CO, USA', domain: 'Enterprise Growth & Global Partnerships', desc: 'Decades of automotive dealership expertise combined with emerging AI innovation — helping enterprises build strategic offshore capabilities and digital transformation initiatives.' },
    { initials: 'SS', name: 'Sneha Seth', role: 'Founder & CMO', domain: 'Global GTM & Brand Strategy', desc: 'Leads market expansion, product positioning and enterprise partnerships for AI-powered solutions, GCC programs and workforce transformation.' },
    { initials: 'SS', name: 'Sanjay Soni', role: 'Chief Technology Officer', domain: 'Enterprise Architecture & Engineering', desc: 'Ex-Microsoft technology leader specialising in cloud transformation, scalable architectures, AI platforms and enterprise engineering excellence.' },
    { initials: 'DK', name: 'Dhananjay Kumar', role: 'Director', domain: 'AI & Innovation Strategy', desc: 'NVIDIA alumnus driving AI adoption, intelligent automation and next-generation technology capabilities across enterprise ecosystems.' },
  ];

  return (
    <div className={styles.lightSection}>
      <div className={styles.section} style={{ paddingTop: '40px' }}>
        <div className={styles.pillLight}>🔹 Trusted Leadership</div>
        <h2 className={styles.sectionTitleLight}>Meet the leaders behind<br/>Provaantech</h2>
        <p className={styles.sectionSubtitleLight}>A team of technology, enterprise and AI leaders helping global organisations build scalable capability centers and digital transformation programs.</p>
        
        <div className={extraStyles.leadersGrid}>
          {leaders.map((leader, index) => (
            <div key={index} className={extraStyles.leaderCard}>
              <div className={extraStyles.leaderAvatar}>{leader.initials}</div>
              <h3>{leader.name}</h3>
              <div className={extraStyles.leaderRole}>{leader.role}</div>
              <div className={extraStyles.leaderDomain}>{leader.domain}</div>
              <p className={extraStyles.leaderDesc}>{leader.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LeadersSection;
